import { Component } from '@angular/core';
import { HeaderComponent } from './header.component';
import { HeroComponent } from './hero.component';
import { AuthorityComponent } from './authority.component';
import { RiskComponent } from './risk.component';
import { NewsComponent } from './news.component';
import { HowItWorksComponent } from './how-it-works.component';
import { PackComponent } from './pack.component';
import { SegmentsComponent } from './segments.component';
import { MetricsComponent } from './metrics.component';
import { FaqComponent } from './faq.component';
import { CtaFormComponent } from './cta-form.component';
import { FooterComponent } from './footer.component';
import { ModalComponent } from './modal.component';
import { BlogCarouselComponent } from './blog-carousel.component';

@Component({
  selector: 'app-home-v3',
  standalone: true,
  imports: [
    HeaderComponent,
    HeroComponent,
    AuthorityComponent,
    RiskComponent,
    NewsComponent,
    HowItWorksComponent,
    PackComponent,
    SegmentsComponent,
    MetricsComponent,
    FaqComponent,
    CtaFormComponent,
    ModalComponent,
    FooterComponent,
    BlogCarouselComponent,
  ],
  template: `
    <app-header></app-header>
    <app-modal></app-modal>
    <main>
      <app-hero></app-hero>
      <app-authority></app-authority>
      <div class="content-auto">
        <app-risk></app-risk>
      </div>
      @defer (on viewport) {
        <div class="content-auto">
          <app-news></app-news>
        </div>
        <div class="content-auto">
          <app-how-it-works></app-how-it-works>
        </div>
        <div class="content-auto">
          <app-pack></app-pack>
        </div>
        <div class="content-auto">
          <app-segments></app-segments>
        </div>
        <div class="content-auto">
          <app-blog-carousel></app-blog-carousel>
        </div>
        <div class="content-auto">
          <app-faq></app-faq>
        </div>
        <div class="content-auto">
          <app-cta-form></app-cta-form>
        </div>
        <div class="content-auto">
          <app-metrics></app-metrics>
        </div>
      } @placeholder {
        <div style="min-height: 2000px"></div>
      }
    </main>
    <app-footer></app-footer>
  `
})
export class HomeV3Component {}
